import { Avatar } from 'antd';
import moment from 'moment';
import { UserTypes } from '../../../shared/constants/enums';
import { SupportChatMessage } from '../models/support-chat-messages';

import './styles.less';

type MessageItemProps = {
  userType: number;
  message: SupportChatMessage;
  getCachedUserData: Function;
};

const MessageItem = ({ userType, message, getCachedUserData }: MessageItemProps) => {
  const { avatarColor, initial } = getCachedUserData(message.senderName, null);

  const getMessageClass = (message: SupportChatMessage, userType: number) => {
    const isAuthorAgent = message.toInsured;

    if ((userType === UserTypes.Agent && isAuthorAgent) || (userType === UserTypes.TruckingCompany && !isAuthorAgent)) {
      return 'self';
    }

    return 'other';
  };

  return (
    <div className={`message-container ${getMessageClass(message, userType)}`}>
      <Avatar style={{ backgroundColor: avatarColor }} className="avatar">
        {initial}
      </Avatar>
      <div className="message-content">
        <span className="message-author">{message.senderName}</span>
        <div className="message-text">{message.body}</div>
        <div className="message-datetime" title={moment(message.createDate).format('YYYY-MM-DD HH:mm:ss')}>
          {moment(message.createDate).format('hh:mm A')}
        </div>
      </div>
    </div>
  );
};

export default MessageItem;
